import { types, flow } from 'mobx-state-tree'
import * as ChatService from "~/services/chat"

const SBCustomer = types
  .model('SBCustomer', {
    // The unique ID of the customer
    id: types.maybeNull(types.integer),
    // The user ID of the customer which is either identical with the user_id in Sendbird Chat platform 
    // or integrated with the account in the social media but not identical
    sendbirdId: types.maybeNull(types.string),
    // A channel type that indicates which channel the customer comes from
    // Valid values are SENDBIRD, FACEBOOK_PAGE, TWITTER_USER, INSTAGRAM_USER, and WHATSAPP_USER
    channelType: types.maybeNull(types.string),
    // The unique ID of a Desk project where the agent belongs
    project: types.maybeNull(types.integer),
    // The date and time when the customer was created, in ISO 8601 format
    createdAt: types.maybeNull(types.string),
    // The name of the customer displayed in the Sendbird Dashboard - Identical with nickname in SB chat platform
    displayName: types.maybeNull(types.string),
    // The URL of the customer's profile image
    photoThumbnailUrl: types.maybeNull(types.string),
    // An array of key-value custom fields that indicates additional information about the customer (Limit 20 elements)
    customFields: types.maybeNull(types.array(types.frozen({}))),
  })
  .views(self => ({
    // get testGetter() {
    //   return "Some calculated customer value"
    // },
  }))
  .actions(self => ({
    // Retrieves a list of customers registered in the application:
    listCustomers: flow(function* listCustomersGen() {
      yield ChatService.listCustomers()
    }),
    // Retrieves information on a specific customer:
    viewCustomer: flow(function* viewCustomerGen(customerID) {
      yield ChatService.viewCustomer(customerID)
    }),
    // Creates a customer:
    createCustomer: flow(function* createCustomerGen() {
      yield ChatService.createCustomer()
    }),
    // Updates custom fields of a specific customer:
    updateCustomFields: flow(function* updateCustomFieldsGen(customerID) {
      yield ChatService.updateCustomFields(customerID)
    }),
  }))

export default SBCustomer
